import type { FunctionComponent } from "react";
import styled from "styled-components";
import { SubConditionItemSkeleton } from "../SubConditionItem/SubConditionItemSkeleton";

// Mirrors CurrentItemBox's outer spacing so the skeleton -> box swap causes
// no layout shift below it.
const StyledWrapper = styled.div`
  margin-bottom: 16px;
`;

/**
 * Loading placeholder for the Current Item box while GetLoopItemData is in
 * flight (useLoopItemOutputs === undefined).
 */
export const CurrentItemSkeleton: FunctionComponent = () => (
  <StyledWrapper data-testid="current-item-skeleton">
    <SubConditionItemSkeleton />
  </StyledWrapper>
);
